import { put, call, takeEvery } from 'typed-redux-saga';

import SettingGateway from '~apis/setting';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { ProjectChangeHistoryStatusEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';

export default function* watchGetPendingProjectListing(api: SettingGateway): SagaWatcherReturnType {
    yield takeEvery('approval/approvalGetPendingProjectListingAttempt', handleGetPendingProjectListing, api);
}

function* handleGetPendingProjectListing(api: SettingGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { index, filters: { status, projectName, dateFrom, dateTo } } = reduxState.approval.pendingProjectListing;

    const convertedStatus = UtilFunctions.Misc.getEnumValueByKey(ProjectChangeHistoryStatusEnum, status);

    if (!index && index !== 0) {
        yield put(combinedActions.approvalGetPendingProjectListingFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        return;
    }

    const response = yield* call([api, api.getProjectChangeHistoryListing], {
        authToken,
        index,
        status: convertedStatus,
        projectName: projectName || undefined,
        dateFrom: dateFrom || undefined,
        dateTo: dateTo || undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.approvalGetPendingProjectListingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.approvalGetPendingProjectListingSuccess(response.data));
    }
}
